/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcIncreaseV1AchState } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_INCREASE_V1_ACH_STATE_ENTITY_NAME = 'exc.increase.v1.Ach';
export const excIncreaseV1AchStateEntity = new schema.Entity<ExcIncreaseV1AchState>(EXC_INCREASE_V1_ACH_STATE_ENTITY_NAME, {}, { idAttribute: 'achId' });

